<template>
    <div class="vgt-wrap__footer vgt-clearfix pl-ml-0">
        <button id="cashflowBtn" v-if="position != undefined && moduleName == 'listVendorPayment' && showCashflowBtn" type="submit" value="Search" class="btn btn-primary mr-3 pull-left" @click="openPaymentTagSection"> Cashflow </button>
        <div class="footer__row-count vgt-pull-left">
            <span class="footer__row-count__label">Show</span>
            <v-select title="Select Per Page"
                    v-model="storeState.perPage"
                    @input="customPerPageChange"
                    name="customPerPage"
                    id="customPerPage"
                    label="text"
                    :clearable="false"
                    :searchable="false"
                    :filterable="false"
                    :options="dropDownPerPage"
                    class="footer__row-count__select"
                    placeholder="Select Per Page">
            </v-select>
        </div>
        <div class="footer__navigation vgt-pull-right">
            <a :class="'footer__navigation__page-btn '+storeState.disPrevBtn" href="javascript:void(0)" @click="customPageChange('prev')">
                <span class="chevron left"></span>
                <span class="prev-link">Prev</span>
            </a>
            <div class="footer__navigation__info">{{storeState.pagePeriod}} of {{this.$parent.totalRecords}}</div>
            <a :class="'footer__navigation__page-btn '+storeState.disNextBtn" href="javascript:void(0)" @click="customPageChange('next')">
                <span class="next-link">Next</span>
                <span class="chevron right"></span>
            </a>
        </div>

    </div>

</template>
<script>

    import Vue from 'vue';
    import {dataTableMixins} from '../../mixins/dataTableMixins';
    import {store} from '../../store/paginationStore.js';
    //import draggable from 'vuedraggable'
    export default {
        name: "customPagination",
        mixins:[dataTableMixins],
        props: {
            moduleName: {
                type: String,
                required: false,
                default:undefined
            },
            pageChanged: {
                type: Function,
            },
            perPageChanged: {
                type: Function,
            },
            position:{
                type:String,
                required: false,
                default:undefined
            },

        },
        // components: {
        //     draggable,
        // },
        data: () => ({
            storeState:store.state,
            columnId:null,
            parentColumns:[],
            columnList:false,
            isColumnConfig:false,
            showCashflowBtn:true

        }),
        mounted: function() {
            var self = this;
            this.customPerPageChange(this.perPage);

            if(self.position != undefined){
                self.$set(self.$parent, 'userColumns', self.$parent.columns);
                // self.checkUserColumns();
            }
        },
        methods: {

            //call when change page
            customPageChange(flag) {

                if ( flag == "next" ) {

                    //if we are on last page than dont increment page and change page
                    var pageTo = this.storeState.page * this.storeState.perPage;
                    if ( pageTo < this.$parent.totalRecords ) {
                    } else {
                        return;
                    }

                    store.pageChange('next');
                    //this.serverParams.page = this.serverParams.page + 1;
                } else {

                    if ( this.storeState.page == 1 ) {
                        return;
                    }
                    store.pageChange('prev');
                    //this.serverParams.page = this.serverParams.page - 1;
                }

                this.pageChanged({currentPage: this.storeState.page});
                //to reset page period
                this.getPagePeriod();
            },

            //call when change perpage count
            customPerPageChange(customPerPage) {

                var self = this;
                this.serverParams.page = 1;
                this.perPageChanged({currentPerPage: customPerPage});
                //change perpage count on bottom and top
                store.perPageChange(customPerPage);
                //reset page to 1
                store.pageChange('reset');
                //to reset page period
                setTimeout(function () {
                    self.getPagePeriod();
                },1500);
            },
            // //generate text for pagination
            getPagePeriod() {

                store.getPagePeriod(this.storeState.perPage,this.$parent.totalRecords);
                // var pageTo = this.serverParams.page * this.perPage;
                // var pageFrom = ( pageTo - this.perPage ) + 1;

                // if ( pageTo < this.total ) {
                //     store.state.pagePeriod = pageFrom +" - "+ pageTo;
                // } else {
                //     store.state.pagePeriod = pageFrom +" - "+ this.total;
                // }
                // this.pagePeriod = store.state.pagePeriod;

            },

            //drag column and change updated column order object
            dragRow() {
                this.$set(this.$parent, 'userColumns', this.parentColumns);
            },
            openNav() {
                if(window.length > 768)
                {
                    document.getElementById("ColumnList").style.width = "350px";
                }else{
                    document.getElementById("ColumnList").style.width = "300px";
                }

              /*document.getElementById("page-content-wrapper").style.marginRight = "350px";*/
            },

            closeNav() {
              document.getElementById("ColumnList").style.width = "0";
              /*document.getElementById("page-content-wrapper").style.marginRight= "0";*/
            },

            //load users datatable column configuration
            checkUserColumns() {

                var self = this;

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/fetch",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        module: self.moduleName
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.loading = false;
                        if ( data.status == "success" && data.code == '200') {

                            var jsonArr = JSON.parse(data.content['columns']);
                            if ( data.content['id'] != undefined && data.content['columns'][0] != undefined ) {

                                //remove dragable params from array
                                var i = 0;
                                var userConfig = JSON.parse(data.content['columns'],(key, value) => {

                                    if ( key == "typeDef" ) {

                                        delete jsonArr[0].typeDef;
                                        i++;
                                        return;
                                    }
                                    return value;
                                });

                                self.parentColumns = JSON.parse(data.content['columns']);
                                self.$set(self.$parent, 'userColumns', userConfig);
                                self.isColumnConfig = true;

                            } else {
                                //in case when user not store column configuration
                                self.$set(self.$parent, 'userColumns', self.$parent.columns);
                                self.parentColumns = self.$parent.columns;
                                self.isColumnConfig = false;
                            }

                        } else {
                            //load default configuration
                            self.$set(self.$parent, 'userColumns', self.$parent.columns);
                            self.parentColumns = self.$parent.columns;
                            self.isColumnConfig = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            //hide show column
            showListColumn: function(event,index) {
                var self = this;

                if (event.target.checked) {
                    self.$set(self.$parent.userColumns[index], 'hidden', false);
                    self.parentColumns[index].hidden = false;
                } else {
                    self.parentColumns[index].hidden = true;
                    self.$set(self.$parent.userColumns[index], 'hidden', true);
                }

            },

            //set default config
            setDefault: function() {

                var self = this;

                if ( !self.isColumnConfig ) {
                    self.$set(self.$parent, 'userColumns', self.$parent.columns);
                    self.parentColumns = self.$parent.columns;
                    self.closeNav();
                    return;
                }


                $("#defaultConfigBtn").val("Processing...");
                $("#defaultConfigBtn").prop("disabled", true);

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/delete",
                    type: "DELETE",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        module: self.moduleName
                    },
                    success: function (data) {

                        $("#defaultConfigBtn").val("Set Default");
                        $("#defaultConfigBtn").prop("disabled", false);
                        if (data.status == "success") {

                            self.$set(self.$parent, 'userColumns', self.$parent.columns);
                            self.parentColumns = self.$parent.columns;

                            self.closeNav();
                            self.isColumnConfig = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        $("#defaultConfigBtn").val("Set Default");
                        $("#defaultConfigBtn").prop("disabled", false);


                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },

            storeColumnConfig: function() {

                var self = this;

                $("#saveColumnConfigBtn").val("Saving ...");
                $("#saveColumnConfigBtn").prop("disabled", true);
                $("#cancelColumnConfigBtn").prop("disabled",true);

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/store",
                    type: "POST",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        module: self.moduleName,
                        columns:JSON.stringify(self.parentColumns)
                    },
                    success: function (data) {

                        //self.loading = false;

                        $("#saveColumnConfigBtn").val("Save");
                        $("#saveColumnConfigBtn").prop("disabled", false);
                        $("#cancelColumnConfigBtn").prop("disabled",false);

                        if (data.status == "success") {
                            self.closeNav();
                            self.isColumnConfig = true;
                            //document.getElementById("ColumnList").style.width = "0";
                        }
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        $("#saveColumnConfigBtn").val("Save");
                        $("#saveColumnConfigBtn").prop("disabled", false);
                        $("#cancelColumnConfigBtn").prop("disabled",false);

                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },

            //cancel button click
            cancelColumnConfig(){

                var self = this;

                if ( !self.isColumnConfig ) {
                    self.$set(self.$parent, 'userColumns', self.$parent.columns);
                    self.parentColumns = self.$parent.columns;
                    self.closeNav();
                    return;
                }

                $.ajax({
                    url: process.env.ROOT_API + "/datatable-config/fetch",
                    type: "POST",
                    headers: this.ajxHeaders,
                    data:{
                        module: self.moduleName
                    },
                    dataType: "json",
                    success: function (data) {

                        //self.loading = false;

                        if ( data.status == "success" && data.code == '200') {

                            var jsonArr = JSON.parse(data.content['columns']);
                            if ( data.content.id != undefined && data.content['columns'][0] != undefined ) {

                                //remove dragable params from array
                                var i = 0;
                                var userConfig = JSON.parse(data.content['columns'],(key, value) => {

                                    if ( key == "typeDef" ) {
                                        // console.log(jsonArr[0].typeDef);
                                        delete jsonArr[0].typeDef;
                                        i++;
                                        return;
                                    }
                                    return value;
                                });

                                self.parentColumns = JSON.parse(data.content['columns']);
                                self.$set(self.$parent, 'userColumns', userConfig);

                            } else {
                                //in case when user not store column configuration
                                self.$set(self.$parent, 'userColumns', self.$parent.columns);
                                self.parentColumns = self.$parent.columns;

                                for(var i=0;i<self.$parent.userColumns.length;i++){
                                    self.$set(self.$parent.userColumns[i], 'hidden', false);
                                }

                                for(var i=0;i<self.parentColumns.length;i++){
                                    self.$set(self.parentColumns[i], 'hidden', false);
                                }
                            }

                        } else {
                            //load default configuration
                            self.$set(self.$parent, 'userColumns', self.$parent.columns);
                            self.parentColumns = self.$parent.columns;

                            for(var i=0;i<self.$parent.userColumns.length;i++){
                                self.$set(self.$parent.userColumns[i], 'hidden', false);
                            }

                            for(var i=0;i<self.parentColumns.length;i++){
                                self.$set(self.parentColumns[i], 'hidden', false);
                            }
                        }

                        document.getElementById("ColumnList").style.width = "0";
                    },
                    error: function (jqXHR, exception) {
                        //self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            //open payment tag section button click
            openPaymentTagSection(){
                var self = this;
                self.$parent.openPaymentTagDiv();
                self.showCashflowBtn = false;

                console.log(self.$parent.userColumns);
                for(var i = 0; i < self.$parent.userColumns.length;i++){

                    if (self.$parent.userColumns[i].field == "confirm_by"){
                        self.$set(self.$parent.userColumns[i], 'hidden', true);
                    }
                    if (self.$parent.userColumns[i].field == "processed_by"){
                        self.$set(self.$parent.userColumns[i], 'hidden', true);
                    }
                }

            },
            //show cashflow button
            showCashflowButton(){
                var self = this;
                self.showCashflowBtn = true;
            }
        }
    };

</script>



// WEBPACK FOOTER //
// src/components/layout/CustomPagination.vue